<script setup>
import { getDuration } from '@/utils';
import { computed } from 'vue';

const props = defineProps({
	item: Object,
});

const imgUrl = computed(() => `/mediafiles/${props.item.img}`)
</script>

<template>
	<div class="service-wr">
		<div class="service-wr__header">
			<img :src="imgUrl" alt="" />
			<h3>{{ item.title }}</h3>
			<span>{{ getDuration(item.duration) }}</span>
		</div>
		<div class="service-wr__content">
			<p>{{ item.text }}</p>
		</div>
	</div>
</template>

<style lang="scss">
.service-wr__header {
	width: fit-content;
	display: grid;
	grid-template: repeat(2, auto);
	grid-template-columns: repeat(2, auto);
	gap: 4px 14px;

	h3 {
		font-size: 16px;
		font-family: 'Raleway';
		font-weight: 600;
	}

	span { font-size: 12px }

	img {
		width: 40px;
		height: 40px;
		grid-row: 1 / 3;
	}
}

.service-wr__content {
	margin-top: 16px;
	font-size: 14px;
}
</style>
